var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-bottom"
        },
        [
          _vm.viewData.account && _vm.viewData.account.parentAccount
            ? _c("h1", { staticClass: "h2" }, [
                _vm._v("\n      Comissões\n      "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: `/#/user/edit/${_vm.viewData.account.parentAccount.user.id}/${_vm.viewData.account.parentAccount.profile}`
                    }
                  },
                  [_vm._v(_vm._s(_vm.viewData.account.parentAccount.user.name))]
                ),
                _vm._v(
                  "\n      por " +
                    _vm._s(_vm.viewData.account.user.name) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "btn-toolbar mb-2 mb-md-0" }, [
            _vm.viewData.account && _vm.viewData.account.parentAccount
              ? _c(
                  "div",
                  { staticClass: "btn-toolbar mb-2 mb-md-0" },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-group mr-2" },
                      [
                        _c(
                          "BaseButtonComponent",
                          {
                            attrs: { variant: "secondary-action" },
                            on: {
                              click: function($event) {
                                return _vm.$bvModal.show("bv-modal-example")
                              }
                            }
                          },
                          [_vm._v("Nova Comissão")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-modal",
                      {
                        attrs: { id: "bv-modal-example", size: "lg" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "modal-title",
                              fn: function() {
                                return [_vm._v("Nova Comissão")]
                              },
                              proxy: true
                            },
                            {
                              key: "modal-footer",
                              fn: function() {
                                return [
                                  _c(
                                    "BaseButtonComponent",
                                    {
                                      staticStyle: { float: "left" },
                                      attrs: { variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$bvModal.hide(
                                            "bv-modal-example"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Fechar")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "BaseButtonComponent",
                                    {
                                      staticStyle: { float: "right" },
                                      attrs: {
                                        variant: "primary-action",
                                        disabled:
                                          _vm.viewData.start || !_vm.state.value
                                      },
                                      on: { click: _vm.save }
                                    },
                                    [
                                      _vm.viewData.saving
                                        ? _c("b-icon", {
                                            attrs: {
                                              icon: "three-dots",
                                              animation: "cylon"
                                            }
                                          })
                                        : _c("span", [
                                            _vm._v("Adicionar comissão")
                                          ])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2203406330
                        )
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("error-container", {
                              attrs: { errors: _vm.viewData.errors || [] }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "input-group-1",
                                  label: "Data inicial",
                                  "label-for": "input-1"
                                }
                              },
                              [
                                _c("b-form-datepicker", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    state: _vm.isOk("start"),
                                    placeholder: "Selecione uma data"
                                  },
                                  model: {
                                    value: _vm.state.start,
                                    callback: function($$v) {
                                      _vm.$set(_vm.state, "start", $$v)
                                    },
                                    expression: "state.start"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-form-invalid-feedback", [
                                  _vm._v(_vm._s(_vm.getError("start")))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "input-group-1",
                                  label: "Data final",
                                  "label-for": "input-1"
                                }
                              },
                              [
                                _c("b-form-datepicker", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    state: _vm.isOk("end"),
                                    placeholder: "Selecione uma data"
                                  },
                                  model: {
                                    value: _vm.state.end,
                                    callback: function($$v) {
                                      _vm.$set(_vm.state, "end", $$v)
                                    },
                                    expression: "state.end"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-form-invalid-feedback", [
                                  _vm._v(_vm._s(_vm.getError("end")))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "input-group-1",
                                  label: "Valor",
                                  "label-for": "input-1"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Informe o valor da comissão",
                                    state: _vm.isOk("value")
                                  },
                                  on: {
                                    keypress: function($event) {
                                      return _vm.isNumber($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.state.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.state, "value", $$v)
                                    },
                                    expression: "state.value"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-form-invalid-feedback", [
                                  _vm._v(_vm._s(_vm.getError("value")))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      this.viewData.account
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-breadcrumb", {
                    attrs: {
                      items: [
                        {
                          text:
                            "Lista de " +
                            this.getProfileName(this.viewData.account.profile),
                          href: "/#/" + this.viewData.account.profile + "s"
                        },
                        {
                          text: "Comissões",
                          href: "#",
                          active: true
                        }
                      ]
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column h-100" },
            [
              _c("v-table", [
                _c("thead", [
                  _c("tr", [
                    _c("td", [_vm._v("Início")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Fim")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Valor")]),
                    _vm._v(" "),
                    _c("td")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.state.list, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", [_vm._v(_vm._s(_vm.formatDate(item.start)))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(item.end ? _vm.formatDate(item.end) : ""))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(item.value ? item.value : 0) + " %")
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "right" } },
                        [
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                size: "sm",
                                title: "Excluir",
                                variant: "danger"
                              },
                              on: { click: () => _vm.remove(item) }
                            },
                            [
                              _c("b-icon", {
                                attrs: { icon: "trash", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("b-pagination-nav", {
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading &&
          _vm.viewData.account &&
          _vm.viewData.account.parentAccount
        ? _c("empty-list")
        : !_vm.viewData.loading &&
          _vm.viewData.account &&
          !_vm.viewData.account.parentAccount
        ? _c("empty-list", {
            attrs: {
              message:
                "Esse consumidor não foi indicado por um parceiro ou comercializador."
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }